import type { Document, DocumentSearch } from '@quromedical/models';
import { useCallback, useMemo, useState } from 'react';
import { strings } from 'strings';
import { trpc } from 'trpc';

type useDocumentsProps = {
  documents: Document[];
  error: string | undefined;
  isLoading: boolean;
  refetch: () => Promise<void>;
  setPageToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  setCount: React.Dispatch<React.SetStateAction<number | undefined>>;
  nextToken: string | undefined;
  cacheKey: string;
};

export const useDocuments = (
  searchParams: DocumentSearch,
): useDocumentsProps => {
  const [pageToken, setPageToken] = useState<string | undefined>('');
  const [count, setCount] = useState<number | undefined>(20);

  const {
    data,
    isLoading: loading,
    error: trpcError,
    refetch,
    isRefetching,
  } = trpc.document.getAll.useQuery(
    {
      ...searchParams,
      pageToken,
      count,
    },
    {
      staleTime: 60000,
    },
  );

  const refetchDocuments = useCallback(async () => {
    await refetch();
  }, [refetch]);

  const documents = useMemo(() => data?.documents || [], [data]);
  const error = trpcError ? strings.GenericErrorMessage : undefined;
  const isLoading = loading || isRefetching;
  const nextToken = useMemo(() => 'todo fix nextToke', []);
  const cacheKey = useMemo(
    () =>
      `allergy:${searchParams.patient}:${count}:${pageToken}:${documents.length}`,
    [searchParams.patient, count, pageToken, documents.length],
  );

  return {
    documents,
    isLoading,
    error,
    refetch: refetchDocuments,
    setPageToken,
    setCount,
    nextToken,
    cacheKey,
  };
};
